import Home from "../components/HomePage/home";
import SampleForm from "../components/sample-form";
import Error from "../components/Security/error";
import Callback from "../components/Security/callback";
import PageNotFound from "../components/Shared/page-not-found";

export const routes = [
  {
    name: "Home",
    path: "/",
    icon: "home",
    title: "Home",
    component: Home,
    onNavBar: true,
    onHomePage: false,
    meta: {
      requiresAuth: false,
    },
  },
  {
    name: "SampleForm",
    path: "/sample-form",
    icon: "pen",
    title: "Sample Form",
    component: SampleForm,
    onNavBar: true,
    onHomePage: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "AdminForm",
    path: "/admin-form",
    icon: "pen",
    title: "Admin Form",
    component: SampleForm,
    onNavBar: true,
    onHomePage: true,
    meta: {
      requiresAuth: true,
      admin: true,
    },
  },
  {
    name: "Error",
    path: "/error",
    title: "Error",
    component: Error,
    onNavBar: false,
  },
  {
    name: "Callback",
    path: "/callback",
    title: "Callback",
    component: Callback,
    onNavBar: false,
    onHomePage: false,
  },
  {
    name: "PageNotFound",
    path: "*",
    title: "Page Not Found",
    component: PageNotFound,
    onNavBar: false,
  },
];
